'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PermissionsProvider = require('./PermissionsProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const RequiresPermission = _ref => {
  let {
    permission,
    fallbackUI,
    children
  } = _ref;
  const {
    [permission]: hasPermission
  } = PermissionsProvider.usePermissions();
  if (hasPermission) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
  return fallbackUI ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, fallbackUI) : null;
};

exports["default"] = RequiresPermission;
